import { useSelector } from "react-redux";
import {RootState} from "@features/store/store";

const useIsMood = () => {
    return useSelector((state: RootState) => state.header.isMood);
};

const useIsScreenWide = ()=>useSelector((state: RootState) =>state.header.isScreenWide)

const useClickedRowKey = ()=>useSelector((state: RootState) =>state.header.clickedRowKey)
const useFilterCountries = () =>  useSelector((state: RootState) => state.header.filterCountries)
const useRegions = () =>  useSelector((state: RootState) => state.header.regions)

const useGenders = () =>useSelector((state:RootState)=>state.header.genders)
const useResidenceRegions = () =>useSelector((state:RootState)=>state.header.residenceRegions)


export {
    useIsMood,
    useIsScreenWide,
    useClickedRowKey,
    useFilterCountries,
    useRegions,
    useGenders,
    useResidenceRegions

};
